import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import VideoPlayer from './components/VideoPlayer/VideoPlayer';
import { jwPlayerConfig, certDifferenceVideo} from './config/certs-difference-video';

ReactDOM.render(
    <VideoPlayer
        playerId='certsDiff-video'
        config={jwPlayerConfig}
        tracks={certDifferenceVideo}
    />,
    document.getElementById('certs-difference-video-container')
);